import { createSlice } from "@reduxjs/toolkit";
import { GetFeedbackAction } from "store/middlewares/feedback";

export const feedbackSlice = createSlice({
  name: "feedback",
  initialState: {
    feedbackLoading: false,
    feedback: [],
  },
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(GetFeedbackAction.pending, (state) => {
        state.feedbackLoading = state.feedback?.data?.length > 0 ? false : true;
        state.feedback = state.feedback?.data?.length > 0 ? state.feedback : [];
      })
      .addCase(GetFeedbackAction.fulfilled, (state, action) => {
        state.feedbackLoading = false;
        state.feedback = action.payload.response;
      })
      .addCase(GetFeedbackAction.rejected, (state) => {
        state.feedbackLoading = false;
        state.feedback = [];
      });
  },
});

export default feedbackSlice.reducer;
